const initialStatus = {
  loading: false,
  success: false,
  error: false,
  data: null,
  message: null,
}

const myContentReducer = (state = {}, action) => {
  switch (action.type) {
    case 'RESET_MY_CONTENT_OBJ':
      return {}
    case 'RESET_MY_CONTENT_STATUS':
      return {
        ...state,
        status: {
          ...state.status,
          [action.payload]: initialStatus,
        },
      }
    case 'MY_CONTENT_ERROR':
      return {
        ...state,
        status: {
          ...state?.status,
          [action?.payload?.action]: {
            ...initialStatus,
            error: true,
            message: action?.payload?.message,
          },
        },
      }
    case 'GET_MY_CONTENT':
      return {
        ...state,
        status: {
          get_my_content: {
            ...initialStatus,
            loading: true,
          },
        },
      }
    case 'SET_MY_CONTENT':
      return {
        ...state,
        content: [...action.payload],
        status: {
          get_my_content: {
            ...initialStatus,
            success: true,
          },
        },
      }
    case 'UPDATE_MY_CONTENT':
      return {
        ...state,
        status: {
          update_my_content: {
            ...initialStatus,
            loading: true,
            data: { ...action.payload },
          },
        },
      }
    case 'UPDATED_MY_CONTENT':
      return {
        ...state,
        status: {
          update_my_content: {
            ...initialStatus,
            success: true,
            message: action?.payload?.message,
          },
        },
      }

    default:
      return state
  }
}

export default myContentReducer
